import axios from "axios";
import { apiAxiomLog } from "./logging";

export const apiGetPlugins = async (client) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/clients/plugins/${client}`,
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api platform apiGetPlugins");
    console.log(error);
    return null;
  }
};

export const apiUpdateClient = async (client, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/clients/${client}`,
        {
          ...data,
        },
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api platform apiUpdateClient");
    console.log(error);
    return null;
  }
};

export const apiGetPlatformOptions = async (client) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/clients/${client}`,
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api platform apiGetPlatformOptions");
    console.log(error);
    return null;
  }
};

export const apiGetActiveCustomFields = async (client) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/fields/active/${client}`,
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api platform apiGetActiveCustomFields");
    console.log(error);
    return null;
  }
};

export const apiGetCustomFields = async (client) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/clients/custom-fields/${client}`,
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api platform apiGetCustomFields");
    console.log(error);
    return null;
  }
};

export const apiCreateCustomField = async (client, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .put(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/clients/custom-fields/${client}`,
        { ...data },
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api platform apiCreateCustomField");
    console.log(error);
    return null;
  }
};

export const apiUpdateCustomField = async (id, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .patch(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/clients/custom-fields/${id}`,
        { ...data },
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          return true;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api platform apiUpdateCustomField");
    console.log(error);
    return null;
  }
};

export const apiGetTags = async (client) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/clients/tags/${client}`,
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    apiAxiomLog({
      stack: "frontEnd",
      function: "lib/api/platform apiGetTags",
      params: client,
      error: error.toString(),
    });
    return null;
  }
};

export const apiGetCurrentVersion = async () => {
  try {
    const result = await axios
      .get(`${process.env.NEXT_PUBLIC_SOCKET_URL}/version`)
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    if (error.message !== "Network Error") {
      apiAxiomLog({
        stack: "frontEnd",
        function: "lib/api/platform apiGetCurrentVersion",
        error: error.toString(),
      });
    }

    return null;
  }
};

export const apiGetNewTopicData = async (client, board) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/clients/new-action/${client}?board=${board}`,
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api platform apiGetNewTopicData");
    console.log(error);
    return null;
  }
};

export const apiGetClientCounters = async (client) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .get(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/counter/list/${client}`,
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api platform apiGetClientCounters");
    console.log(error);
    return null;
  }
};

export const apiCreateNewCounter = async (data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .post(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/counter/new`,
        { ...data },
        config
      )
      .then(function (response) {
        if (response.status === 200 || response.status === 201) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api platform apiGetClientCounters");
    console.log(error);
    return null;
  }
};

export const apiUpdateCounter = async (id, data) => {
  try {
    const config = {
      headers: {
        Authorization: `Bearer ${process.env.NEXT_PUBLIC_AUTH_TOKEN}`,
      },
    };
    const result = await axios
      .patch(
        `${process.env.NEXT_PUBLIC_SOCKET_URL}/api/counter/update/${id}`,
        { ...data },
        config
      )
      .then(function (response) {
        if (response.status === 200) {
          const { data } = response;
          return data;
        } else {
          return null;
        }
      });
    return result;
  } catch (error) {
    console.log("error api platform apiGetClientCounters");
    console.log(error);
    return null;
  }
};
